import { ClientId } from 'magpie-types';
import { getUUID } from './get-uuid';

export const generateClientId = getUUID as () => ClientId;
